import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { BaseService } from '@kodit/core/services';
import {
  PdvEvidencijaPojedinacna39Dto,
  PdvEvidencijaPojedinacnaDto,
  PdvEvidencijeClient,
} from '@kodit/core/data-api';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PdvEvidencijaPojedinacna39Resolver
  extends BaseService
  implements Resolve<PdvEvidencijaPojedinacna39Dto> {
  constructor(private _client: PdvEvidencijeClient) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<PdvEvidencijaPojedinacna39Dto>
    | Promise<PdvEvidencijaPojedinacna39Dto>
    | PdvEvidencijaPojedinacna39Dto
    | null {
    const id = Number.parseInt(route.paramMap.get('id') ?? '');
    return this._client.getPdvEvidencijaPojedinacna39(id).pipe(
      map((x) => x.data),
      catchError(this.handleError),
      finalize(() => {
        //this._configService.setIsBusy = false;
      })
    );
  }
}
